/** End-face layout — keep in sync with camera fit in calcProcessingFitSize */
export const PROCESSING_SIDE_INDENT = 0.3
export const PROCESSING_SIDE_THICKNESS = 0.2
/** MainDimension label offset in DetailProcessing */
export const PROCESSING_DIMENSION_LABEL_OFFSET = 0.65
const PROCESSING_FIT_LABEL_SLACK = 0.15

export const calcProcessingFitSize = (length, width, scale) => {
    const endFacePad = PROCESSING_SIDE_INDENT + PROCESSING_SIDE_THICKNESS
    const labelPad = PROCESSING_DIMENSION_LABEL_OFFSET + PROCESSING_FIT_LABEL_SLACK
    const pad = Math.max(endFacePad, labelPad)
    const safeScale = Number(scale) || 0
    const safeLength = Math.max(Number(length) || 0, 0)
    const safeWidth = Math.max(Number(width) || 0, 0)
    return {
        width: Math.max(safeLength * safeScale + pad * 2, 0.001),
        height: Math.max(safeWidth * safeScale + pad * 2, 0.001),
    }
}

export const calcSidePos = (side, detailData, scale) => {
    const thickness = PROCESSING_SIDE_THICKNESS
    const indent = PROCESSING_SIDE_INDENT

    let xPos
    let yPos

    const x = side === 'BACK' || side === 'FRONT' ? detailData.length * scale : thickness
    const y = side === 'LEFT' || side === 'RIGHT' ? detailData.width * scale : thickness

    if (side === 'LEFT') {
        xPos = -indent
    } else if (side === 'RIGHT') {
        xPos = detailData.length * scale + indent
    } else {
        xPos = detailData.length / 2 * scale
    }

    if (side === 'FRONT') {
        yPos = -indent
    } else if (side === 'BACK') {
        yPos = detailData.width * scale + indent
    } else {
        yPos = detailData.width / 2 * scale
    }

    return {xPos, yPos, x, y}
}